import { useEffect, useState } from 'react';
import { checkAuth } from '../services/authService'; // Make sure path is correct
import useAuthRedirect from './useAuthRedirect';     // Make sure path is correct

/**
 * Custom hook to redirect authenticated users away from public authentication routes.
 * It checks if a user is logged in on component mount and redirects them to their
 * appropriate dashboard based on their role.
 */
const useRedirectIfAuthenticated = () => {

    const redirectToUserDashboard = useAuthRedirect(); // Get the role-based redirect function
    const [isLoadingAuthCheck, setIsLoadingAuthCheck] = useState(true); // New state


    useEffect(() => {
        const verifyAuthAndRedirect = async () => {
            try {
                const  user = await checkAuth(); // Check if the user is authenticated
                if (user) {
                    // If authenticated, redirect them to their dashboard
                    console.log("User already authenticated. Redirecting from public route.");
                    redirectToUserDashboard();
                }
            } catch (err) {
                // Handle potential errors during the auth check, but remain on the current page
                // if the user is not authenticated (or check failed, indicating not authenticated)
                console.error("Error during authentication check in useRedirectIfAuthenticated:", err);
            } finally {
                setIsLoadingAuthCheck(false);

            }
        };

        verifyAuthAndRedirect();
    }, [redirectToUserDashboard]); // Dependency: The redirect function itself

    return isLoadingAuthCheck; // Return the loading state

};

export default useRedirectIfAuthenticated;